export default "__VITE_ASSET__CAkglsEN__"